import { useEffect } from "react";
import { useModalStore } from "./store/useModalStore";
import { modalRegistry } from "./constants/modal.constants";

export const GlobalModalRenderer = () => {
  const { modals, closeModal } = useModalStore();

  useEffect(() => {
    if (modals.length > 0) {
      const originalStyle = document.body.style.overflow;
      document.body.style.overflow = "hidden";

      return () => {
        document.body.style.overflow = originalStyle;
      };
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modals.length]);

  return (
    <>
      {modals.map(({ id, key, props }) => {
        const Component = modalRegistry[key];
        if (!Component) {
          console.error(
            `Modal component for key "${key}" not found in registry.`,
          );
          return null;
        }
        return (
          <Component
            key={id}
            {...(props as any)}
            close={() => closeModal(id)}
          />
        );
      })}
    </>
  );
};
